import React, { useState } from 'react';
import { Study } from '../StudyTypes';
import HistoryModal from 'pages/StudyList/HistoryModal';
import { getReviewId } from 'query/review';
import { QueryProvider } from 'query/QueryProvider';
import { TertiaryButton } from 'system/base/Button';

type HistoryButtonProps = {
  study: Study;
};

export function HistoryButton({ study }: HistoryButtonProps): JSX.Element {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const reviewId = getReviewId();

  return (
    <>
      <TertiaryButton
        iconName="history"
        onClick={() => setIsModalOpen(true)}
        data-pendo-key="extraction-history-button"
      >
        History
      </TertiaryButton>

      {isModalOpen && (
        // Only render the QueryProvider & HistoryModal when the modal is open
        // to avoid unnecessary query client initializations.
        <QueryProvider>
          <HistoryModal
            isOpen={true}
            onClose={() => setIsModalOpen(false)}
            reviewId={reviewId ? parseInt(reviewId) : 0}
            studyId={study.id}
            studyTitle={study.title || '[Untitled reference]'}
            category="Included"
            // The DE2 history view hides covidence.data_extraction.* and covidence.quality_assessment.* events.
            // These particular events are inaccurate under DE2 and would be confusing to reviewers, whereas the
            //  rest of the timeline (notes, documents, votes, merges, etc.) is genuinely helpful — so we filter
            //  out only those two event families rather than suppressing the history altogether.
            excludeNamePrefixes={[
              'covidence.data_extraction',
              'covidence.quality_assessment',
            ]}
          />
        </QueryProvider>
      )}
    </>
  );
}
